module.exports = __webpack_public_path__ + "assets/asset_database.90dc54f2.svg";